import { SmartTable } from '../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor(
        $state,
        $window,
        $timeout,
        $scope,
        Alert,
        AddNewSharedAuthenticatorModal,
        ImportSharedAuthenticatorsModal,
        ManageSharedAuthenticatorModal,
        SharedAccountShare,
        SharedAccountsService
    ) {
        this.$state = $state;
        this.$window = $window;
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.Alert = Alert;
        this.AddNewSharedAuthenticatorModal = AddNewSharedAuthenticatorModal;
        this.ImportSharedAuthenticatorsModal = ImportSharedAuthenticatorsModal;
        this.ManageSharedAuthenticatorModal = ManageSharedAuthenticatorModal;
        this.SharedAccountShare = SharedAccountShare;
        this.SharedAccountsService = SharedAccountsService;
		this.st= new SmartTable();
    }

    $onInit() {
    }

    copyToClipboard(value) {
        navigator.clipboard.writeText(value)
            .then(this.Alert('success', 'global.data_copied'));          
    }

    reload() {
        return this.$state.reload(this.$state.current);
    }

    export(accounts) {
        let accountIds = accounts.map((item) => item.id);
        let companyId = this.companyId;
        this.SharedAccountsService.exportCompanyServiceAccounts({companyId}, accountIds)
                .$promise
                .then((response) => {
                    var file = new Blob([response.data], {
                        type : 'text/plain'
                    });
                    var windowUrl = this.$window.URL;
                    var fileURL = windowUrl.createObjectURL(file);
                    var a = document.createElement('a');
                    a.href = fileURL;
                    a.target = '_blank';
                    a.download = 'exported_authenticators_' + new Date().valueOf() + '.csv';
                    document.body.appendChild(a);
                    a.click();
                    setTimeout(function() { windowUrl.revokeObjectURL(fileURL); }, 100);
                    this.Alert('success', 'company.sharing-center.shared-accounts.export-succes');
                })
                .catch(error => {
                    this.Alert('danger', error.message);
                });
    }

    getOtp(p) {
        var param = {
            companyId: this.companyId,
            id : p.id
        };
        return this.SharedAccountsService.getOtp(param)
            .$promise
            .then((data) => {
                p.otp = data.otp;
            })
            .then(() => this.$timeout(30000))
            .then(() => p.mustRenewOtp = true);
    }

    renewOTP(p) {
        var param = {
            companyId: this.companyId,
            id : p.id
        };
        return this.SharedAccountsService.getOtp(param)
            .$promise
            .then((data) => {
                p.otp = data.otp;
            })
            .then(() => p.mustRenewOtp = false)
            .then(() => this.$timeout(30000))
            .then(() => p.mustRenewOtp = true);
    }

    showAddModal() {
       /* this.publicServicesWithSsoAnd2FA$.get()
            .then(items => this.AddNewSharedAuthenticatorModal(items))
            .then(() => this.reload())*/
            
             this.$state.go('company.sharing-center.add-shared-authenticator');
    }

    showImportModal() {
        return this.ImportSharedAuthenticatorsModal().then(() => this.reload());
    }

    showManageModal(account) {
        return this.ManageSharedAuthenticatorModal(account).then(() => this.reload());
    }

    showShareModal(account) {
        this.$state.go('company.sharing-center.shared-authenticators.manage.share',{sharedAccount: account,sharedAccountId: account.id});
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-authenticators/shared-authenticators.controller.js